import Proxy from '../Proxy';

class StatsContactProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param orderType
   * @param {Object} parameters The query parameters.
   */
  constructor(orderType, parameters = {}) {
    super('stats/contacts', parameters);
  }

  general(uuid) {
    return this.submit('get', `${this.endpoint}/${uuid}`);
  }
}

export default StatsContactProxy;
